import { render, staticRenderFns } from "./nuevo_periodo.vue?vue&type=template&id=1b7679ab&"
import script from "./nuevo_periodo.vue?vue&type=script&lang=js&"
export * from "./nuevo_periodo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports